import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Option } from '../../../../shared/models/option.model';
import { SelectConfig } from '../../../../shared/ui/form/select/select.component.config';
import { TableConfig } from '../../../../shared/ui/custom-table/model/table-config.model';

@Component({
    selector: 'app-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.css'],
    standalone: false
})
export class ContactFormComponent implements OnInit {
    @ViewChild('expandTemplate', {static: false}) productMovementsTemplate!: TemplateRef<any>;
    @ViewChild('invoiceSummary', {static: false}) invoiceSummary!: TemplateRef<any>;


    invoices = [
        {
            number: 'F2025-001',
            date: '2025-06-20',
            dateExpiration: '2025-07-20',
            cif: '12345678Z',
            total: '108.52€',
            customer: 'Empresa XYZ',
            lines: [
                { product: 'Monitor', quantity: 1, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
                { product: 'Monitor2', quantity: 2, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
            ]
        },
        {
            number: 'F2025-001',
            date: '2025-06-20',
            dateExpiration: '2025-07-20',
            cif: '12345678Z',
            total: '108.52€',
            customer: 'Empresa XYZ',
            lines: [
                { product: 'Monitor', quantity: 1, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
                { product: 'Monitor2', quantity: 2, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
            ]
        },
        {
            number: 'F2025-001',
            date: '2025-06-20',
            dateExpiration: '2025-07-20',
            cif: '12345678Z',
            total: '108.52€',
            customer: 'Empresa XYZ',
            lines: [
                { product: 'Monitor', quantity: 1, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
                { product: 'Monitor2', quantity: 2, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
            ]
        },
        {
            number: 'F2025-001',
            date: '2025-06-20',
            dateExpiration: '2025-07-20',
            cif: '12345678Z',
            total: '108.52€',
            customer: 'Empresa XYZ',
            lines: [
                { product: 'Monitor', quantity: 1, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
                { product: 'Monitor2', quantity: 2, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
            ]
        },
        {
            number: 'F2025-001',
            date: '2025-06-20',
            dateExpiration: '2025-07-20',
            cif: '12345678Z',
            total: '108.52€',
            customer: 'Empresa XYZ',
            lines: [
                { product: 'Monitor', quantity: 1, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
                { product: 'Monitor2', quantity: 2, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
            ]
        },
        {
            number: 'F2025-001',
            date: '2025-06-20',
            dateExpiration: '2025-07-20',
            cif: '12345678Z',
            total: '108.52€',
            customer: 'Empresa XYZ',
            lines: [
                { product: 'Monitor', quantity: 1, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
                { product: 'Monitor2', quantity: 2, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
            ]
        },
        {
            number: 'F2025-001',
            date: '2025-06-20',
            dateExpiration: '2025-07-20',
            cif: '12345678Z',
            total: '108.52€',
            customer: 'Empresa XYZ',
            lines: [
                { product: 'Monitor', quantity: 1, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
                { product: 'Monitor2', quantity: 2, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
            ]
        },
        {
            number: 'F2025-001',
            date: '2025-06-20',
            dateExpiration: '2025-07-20',
            cif: '12345678Z',
            total: '108.52€',
            customer: 'Empresa XYZ',
            lines: [
                { product: 'Monitor', quantity: 1, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
                { product: 'Monitor2', quantity: 2, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
            ]
        },
        {
            number: 'F2025-001',
            date: '2025-06-20',
            dateExpiration: '2025-07-20',
            cif: '12345678Z',
            total: '108.52€',
            customer: 'Empresa XYZ',
            lines: [
                { product: 'Monitor', quantity: 1, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
                { product: 'Monitor2', quantity: 3, price: 120, discount: 10, taxes: 'IVA general(21%)', total: 120 },
            ]
        },
    ];


    tableConfig: TableConfig = {
        columns: [
            { key: 'number', label: 'Presupuesto' },
            { key: 'customer', label: 'Destinatario' },
            { key: 'cif', label: 'CIF/NIF' },
            { key: 'total', label: 'Total' },
            { key: 'date', label: 'Fecha', formatFn: v => new Date(v).toLocaleDateString() },
            { key: 'dateExpiration', label: 'Fecha vencimiento', formatFn: v => new Date(v).toLocaleDateString() },
        ],
        actions: [
            {
                label: 'Ver PDF',
                icon: 'fa fa-file-pdf',
                callback: (row) => console.log('Ver PDF', row),
            }
        ],
        headerActions: [
            {
                label: 'Añadir nueva factura',
                icon: 'fa fa-plus',
                type: 'button', // se muestra como botón
                callback: () => console.log('add')  //this.addInvoice(),
            },
            {
                label: 'Eliminar seleccionadas',
                icon: 'delete',
                type: 'menu', // se agrupa en el menú
                callback: (rows) => console.log('delete') //this.deleteInvoices(rows),
            },
            {
                label: 'Exportar',
                icon: 'download',
                type: 'menu',
                callback: (rows) => console.log('export') //this.exportInvoices(rows),
            },
        ],
        selectable: true,
        pagination: false,
        expandableRowTemplate: this.productMovementsTemplate, // En tu componente padre
        summaryTemplate: this.productMovementsTemplate, // En tu componente padre
    };


    form!: UntypedFormGroup;

    activeTab = 'general';

    formConfiguration: any = {
        companyName: {
            label: 'Nombre / Razón social',
            placeholder: 'Nombre / Razón social',
        },
        vatNumber: {
            label: 'DNI / CIF',
            placeholder: 'DNI / CIF',
        },
        isClient: {
            id: 'isClient',
            label: '',
            placeholder: '',
        },
        isProvider: {
            id: 'isProvider',
            label: '',
            placeholder: '',
        },
        isDebtor: {
            id: 'isDebtor',
            label: '',
            placeholder: '',
        },
    }

    constructor(private fb: UntypedFormBuilder) { }

    ngOnInit(): void {
        this.tableConfig.expandableRowTemplate = this.productMovementsTemplate;
        this.tableConfig.summaryTemplate = this.invoiceSummary;


        this.form = this.fb.group({
            companyName: [null, Validators.required],
            vatNumber: [null, Validators.required],

            streetTypeId: [null, Validators.required],
            address: [null, Validators.required],
            number: [null, Validators.required],
            block: [null, Validators.required],
            entrance: [null, Validators.required],
            staircase: [null, Validators.required],
            floor: [null, Validators.required],
            door: [null, Validators.required],
            countriesCode: [null, Validators.required],
            provinceCode: [null, Validators.required],
            municipalityCode: [null, Validators.required],
            postalCode: [null, Validators.required],
            email: [null, Validators.required],
            residenceTypeId: [null, Validators.required],
            bankAccount: [null, Validators.required],
            bic: [null, Validators.required],
            phone: [null, Validators.required],
            contactPerson: [null, Validators.required],
            taxRepresentativeNIF: [null, Validators.required],

            isClient: [false],
            paymentTypeClient: [null, Validators.required],
            paymentClientUid: [null, Validators.required],
            clientEfectivoId: [null, Validators.required],
            clientPartnersId: [null, Validators.required],
            entranceAccount: [null, Validators.required],
            accountNumberClient: [null, Validators.required],
            taxClientUid: [null, Validators.required],
            taxClientSecondUid: [null, Validators.required],
            expirationClient: [null, Validators.required],
            assignedCode: [null, Validators.required],

            isProvider: [false],
            paymentTypeProvider: [null, Validators.required],
            paymentProviderUid: [null, Validators.required],
            providerEfectivoId: [null, Validators.required],
            providerPartnersId: [null, Validators.required],
            expenseAccountProvider: [null, Validators.required],
            accountNumberProvider: [null, Validators.required],
            taxProviderUid: [null, Validators.required],
            taxProviderSecondUid: [null, Validators.required],
            expirationProvider: [null, Validators.required],
            arrendador: [null, Validators.required],
            referencia_catastro: [null, Validators.required],

            isDebtor: [false],
            paymentTypeDebtor: [null, Validators.required],
            paymentDebtorUid: [null, Validators.required],
            debtorEfectivoId: [null, Validators.required],
            debtorPartnersId: [null, Validators.required],
            accountNumberDebtor: [null, Validators.required],
            taxDebtorUid: [null, Validators.required],
            taxDebtorSecondUid: [null, Validators.required],
            expirationDebtor: [null, Validators.required],
        });

        // this.form.get('provincia')!.valueChanges.subscribe(value => {
        //     this.onProvinciaChange();
        // });

    }

    onSubmit(): void {
        if (this.form.valid) {
        } else {
            this.markAllControlsAsTouched(this.form);
        }
    }

    markAllControlsAsTouched(formGroup: UntypedFormGroup): void {
        Object.keys(formGroup.controls).forEach(controlName => {
            const control = formGroup.get(controlName);
            if (control instanceof UntypedFormGroup) {
                this.markAllControlsAsTouched(control);
            } else {
                control!.markAsTouched();
            }
        });
    }

    provinciaConfig: SelectConfig = {
        label: 'Provincia',
        placeholder: 'Selecciona provincia',
        multiple: false,
        loadOptions: () => this.loadProvincias()
    };

    municipioConfig: SelectConfig = {
        label: 'Municipio',
        placeholder: 'Selecciona municipio',
        multiple: false,
        loadOptions: () => this.loadMunicipios(this.form.get('provincia')!.value)
    };

    loadProvincias(): Option[] {
        return [
            { value: '08', label: 'Barcelona' },
            { value: '28', label: 'Madrid' }
        ];
    }

    loadMunicipios(provincia: string): Option[] {
        if (provincia === '08') {
            return [
                { value: '08019', label: 'Barcelona' },
                { value: '08101', label: 'L\'Hospitalet' }
            ];
        } else if (provincia === '28') {
            return [
                { value: '28079', label: 'Madrid' },
                { value: '28123', label: 'Getafe' }
            ];
        }
        return [];
    }

    onProvinciaChange(): void {
        const provincia = this.form.get('provincia')!.value;
        this.municipioConfig = {
            ...this.municipioConfig,
            key: Date.now(), // clave única que cambia en cada llamada
            loadOptions: () => this.loadMunicipios(provincia)
        };

        this.form.get('municipio')!.reset();
    }

    onTabClick(controlName: string, tab: string): void {
        if (!this.form.get(controlName)!.value) return;

        this.activeTab = tab;
    }
  public trackByIndex(i: number) { return i; }

}
